import { IUserDisplay } from '../../../../../utils/api_service/access_control';
import { SelectOptions } from '../../../../../utils/types/react_select_types';

interface RawJobUser {
  id?: string;
  user?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    id?: string;
  };
}

interface RawOptionOrUser {
  id?: string;
  label?: string;
  value?: string;
  user?: {
    firstName?: string;
    lastName?: string;
  };
}

export const safeJobUserToUserDisplay = (jobUser: unknown): IUserDisplay | undefined => {
  if (
    !jobUser ||
    typeof jobUser !== 'object'
  ) {
    return undefined;
  }

  const raw = jobUser as RawJobUser;
  if (!raw.user || typeof raw.user.firstName !== 'string') {
    return undefined;
  }

  return {
    firstName: raw.user.firstName,
    lastName: raw.user.lastName || '',
    email: raw.user.email || '',
    id: raw.user.id || '',
    orgUserId: raw.id || '',
    permissions: [],
  };
};

export const userToSelectOption = (u: unknown): SelectOptions | null => {
  if (!u || typeof u !== 'object') return null;

  const raw = u as RawOptionOrUser;
  if (raw.label && raw.value) {
    return {
      label: raw.label,
      value: raw.value,
    };
  }

  if (raw.user && typeof raw.user === 'object') {
    const firstName = raw.user.firstName || '';
    const lastName = raw.user.lastName || '';
    return {
      value: raw.id || '',
      label: `${firstName} ${lastName}`.trim(),
    };
  }

  return null;
};

export const formatJobTitleOption = (
  jobTitle: unknown,
  fallbackLabel?: string
): { value: string; label: string } => {
  if (jobTitle && typeof jobTitle === 'object') {
    const raw = jobTitle as { id?: string; value?: string; jobTitle?: string; label?: string };
    return {
      value: raw.id || raw.value || '',
      label: raw.jobTitle || raw.label || '',
    };
  }

  const stringVal = typeof jobTitle === 'string' ? jobTitle : '';
  return {
    value: stringVal,
    label: fallbackLabel || stringVal,
  };
};
